import React, { Component } from "react";
import Layout from "../components/Layout";
import BadgeGroupCsvJobPage from "../components/BadgeGroupCsvJobPage";

export const BADGE_GROUP_CSV_JOB_PAGE_TITLE = "Badge Group Download From CSV";
export const BADGE_GROUP_CSV_JOB_PAGE_URL = "/badge-group/download-zip";

export class BadgeGroupCsvJobContainer extends Component {
  render() {
    return (
      <Layout {...this.props} title={BADGE_GROUP_CSV_JOB_PAGE_TITLE}>
        <BadgeGroupCsvJobPage />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BadgeGroupCsvJobContainer.js